var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcpServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3984_62937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.70215 5.52365C3.70215 4.80756 4.28991 4.22705 5.01493 4.22705C5.73997 4.22705 6.32772 4.80756 6.32772 5.52365C6.32772 6.23973 5.73997 6.82024 5.01493 6.82024C4.28991 6.82024 3.70215 6.23973 3.70215 5.52365Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 5.52365C7.64062 4.80756 8.22839 4.22705 8.95337 4.22705C9.67842 4.22705 10.2662 4.80756 10.2662 5.52365C10.2662 6.23973 9.67842 6.82024 8.95337 6.82024C8.22839 6.82024 7.64062 6.23973 7.64062 5.52365Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01493 13.3032C4.28991 13.3032 3.70215 13.8837 3.70215 14.5998C3.70215 15.3159 4.28991 15.8964 5.01493 15.8964C5.73997 15.8964 6.32772 15.3159 6.32772 14.5998C6.32772 13.8837 5.73997 13.3032 5.01493 13.3032Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95337 13.3032C8.22839 13.3032 7.64062 13.8837 7.64062 14.5998C7.64062 15.3159 8.22839 15.8964 8.95337 15.8964C9.67842 15.8964 10.2662 15.3159 10.2662 14.5998C10.2662 13.8837 9.67842 13.3032 8.95337 13.3032Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63262 0.0131836C1.63878 0.0131836 0.0224609 1.60958 0.0224609 3.57882V7.46861C0.0224609 8.49034 0.45757 9.41169 1.15478 10.0618C0.45757 10.7119 0.0224609 11.6333 0.0224609 12.655V16.5448C0.0224609 18.5141 1.63878 20.1104 3.63262 20.1104H10.5938V22.0553H2.38894C1.84517 22.0553 1.40435 22.4907 1.40435 23.0278C1.40435 23.5648 1.84517 24.0002 2.38894 24.0002H20.7679C21.3117 24.0002 21.7525 23.5648 21.7525 23.0278C21.7525 22.4907 21.3117 22.0553 20.7679 22.0553H12.563V20.1104H19.3861C21.3799 20.1104 22.9962 18.5141 22.9962 16.5448V12.655C22.9962 11.6333 22.561 10.7119 21.8639 10.0618C22.561 9.41169 22.9962 8.49036 22.9962 7.46861V3.57882C22.9962 1.60958 21.3799 0.0131836 19.3861 0.0131836H3.63262ZM3.63262 9.08936H19.3861C20.2923 9.08936 21.027 8.36373 21.027 7.46861V3.57882C21.027 2.68371 20.2923 1.95808 19.3861 1.95808H3.63262C2.72633 1.95808 1.99164 2.68371 1.99164 3.57882V7.46861C1.99164 8.36373 2.72633 9.08936 3.63262 9.08936ZM3.63262 11.0343C2.72633 11.0343 1.99164 11.7598 1.99164 12.655V16.5448C1.99164 17.44 2.72633 18.1655 3.63262 18.1655H19.3861C20.2923 18.1655 21.027 17.44 21.027 16.5448V12.655C21.027 11.7598 20.2923 11.0343 19.3861 11.0343H3.63262Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3984_62937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcpServer);
export default __webpack_public_path__ + "static/media/mcp-server.f34e8f174a68c1ac6084d5b80a5ce0e0.svg";
export { ForwardRef as ReactComponent };